import React from 'react';
import { Tag } from 'antd';
import PropTypes from 'prop-types';

/**
 * Estado actual de una solicitud de gasto, en una sola etiqueta.
 *
 * La tabla mostraba el avance completo (En proceso > Adquisición > Entregado >
 * Recibido) en cada fila, así que todas las filas parecían iguales y había que
 * leer el paso resaltado. Aquí solo se dice dónde está la solicitud ahora.
 *
 * Los campos vienen de tres columnas de `purchase_requests`:
 * - `table_name` del estatus (pedido-en-proceso, pedido-en-compra, ...)
 * - `type_status`: 'normal' o 'cancelado'
 * - `approved_status`: pendiente, en aprobación por administrador, aprobada,
 *   rechazada, devolución
 * Una solicitud cancelada o rechazada conserva el estatus donde se quedó, por eso
 * el estado terminal (rechazada, cancelada, devolución) manda sobre el paso.
 */
export const estadoSolicitud = (tableName, typeStatus, approvedStatus) => {
  const paso = (tableName || '').trim();
  const tipo = (typeStatus || '').trim();
  const aprobacion = (approvedStatus || '').trim();

  if (aprobacion === 'rechazada') return { label: 'Rechazada', color: 'red' };
  if (tipo === 'cancelado') return { label: 'Cancelada', color: 'default' };
  if (aprobacion === 'devolución' || paso === 'pedido-devolución') {
    return { label: 'Devolución', color: 'orange' };
  }

  switch (paso) {
    case 'pedido-recibido':
      return { label: 'Recibido', color: 'green' };
    case 'pedido-entregado':
      return { label: 'Entregado', color: 'cyan' };
    case 'pedido-en-compra':
      return { label: 'En adquisición', color: 'blue' };
    case 'pedido-en-proceso':
      if (aprobacion === 'pendiente') return { label: 'Pendiente de jefe directo', color: 'gold' };
      if (aprobacion.startsWith('en aprobación')) {
        return { label: 'Por aprobar (administrador)', color: 'gold' };
      }
      return { label: 'En proceso', color: 'processing' };
    default:
      return { label: 'Sin estado', color: 'default' };
  }
};

const EstadoSolicitud = ({ tableName, typeStatus, approvedStatus }) => {
  const { label, color } = estadoSolicitud(tableName, typeStatus, approvedStatus);

  return (
    <Tag color={color} style={{ marginInlineEnd: 0 }}>
      {label}
    </Tag>
  );
};

EstadoSolicitud.propTypes = {
  tableName: PropTypes.string,
  typeStatus: PropTypes.string,
  approvedStatus: PropTypes.string
};

export default EstadoSolicitud;
